import { ServerEnv } from '@c42/jwt';
import { LogoutRedirectApp } from '@c42/jwt/dist/constants';
import React from 'react';

export const STEP_USERNAME = 'username';
export const STEP_PASSWORD = 'password';
export const STEP_TOTP_CONFIG = 'totp-config';
export const STEP_TOTP_INVALID = 'totp-invalid';
export const STEP_TOTP_SN_WARNING = 'totp-sn-warning';

export type SsoLoginUrl = {
  displayName: string;
  loginUrl: string;
};

export type AuthData = {
  // Data from Server
  totpSecret?: string;
  logoutRedirectApp?: LogoutRedirectApp;

  // Data from User
  password?: string;
  totp?: string;
  username?: string;
  ssoLoginUrls?: SsoLoginUrl[];

  // Errors
  loginError?: string;

  // Form State
  currentStep: string;
  isAuthenticating: boolean;
  isUsingTotp: boolean;
  serverType?: ServerEnv['serverType'];
};

export type AuthenticateOptions = {
  loginToken?: string;
  isLogin?: boolean;
  username?: string;
  password?: string;
  totp?: string;
};

export const DEFAULT_AUTH_DATA: AuthData = {
  currentStep: STEP_USERNAME,
  isAuthenticating: false,
  isUsingTotp: false,
};

type AuthDataContextValue = {
  authData: AuthData;
  authenticate: (opts?: AuthenticateOptions) => Promise<void>;
  getServerEnv: () => Promise<ServerEnv>;
  resetForm: () => void;
  setAuthData: React.Dispatch<React.SetStateAction<AuthData>>;
  submitLogin: () => void;
};

export const AuthDataContext = React.createContext<AuthDataContextValue>({
  authData: DEFAULT_AUTH_DATA,
  authenticate: () => Promise.resolve(),
  getServerEnv: () => Promise.resolve(null as unknown as ServerEnv),
  resetForm: () => null,
  setAuthData: () => null,
  submitLogin: () => null,
});
